import API from 'src/plugins/api/api'
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      isConvertedListPublic: false
    }
  },
  computed: {
    isContactsRoute () {
      return this.$route.meta.title === 'Contacts'
    },
    isListsManagementRoute () {
      return this.$route.meta.title === 'Lists Management Utility'
    },
    foldersPath () {
      return (this.isContactsRoute || this.isListsManagementRoute) ? '/api/v2/contact-folders' : '/api/v2/power-dialer-folders'
    }
  },
  methods: {
    ...mapActions('contacts', [
      'foldersLoaded',
      'setPublicLists',
      'setPublicListsLoaded'
    ]),

    reloadFolders () {
      return this.$axios
        .get(this.foldersPath)
        .then((response) => response.data)
        .then(this.foldersLoaded)
        .catch((_err) => {
          this.$generalNotification('Unable to load folders please try again.', 'error')
        })
    },

    async getListsV2 (params = {}) {
      return API.V2.contactList.get(params).then(response => {
        return response.data.data
      }).catch((err) => {
        console.error(err)
        this.$generalNotification('Unable to load contact lists please try again.', 'error')
      })
    },

    async getPublicListsV2 (params) {
      return API.V2.contactList.public(params).then(response => {
        return response.data.data
      }).catch((err) => {
        console.error(err)
        this.$generalNotification('Unable to load public contact lists please try again.', 'error')
      })
    },

    async updateContactList (id, params) {
      await API.V2.contactList.update(id, params)
    },

    loadPublicLists () {
      this.isLoading = true
      this.setPublicListsLoaded(false)
      this.publicLists = []
      API.V2.contactList.public({
        page: this.paginationPage,
        size: this.perPage
      }).then(response => {
        const total = response.data.total
        this.lastPage = Math.ceil(total > this.perPage ? Math.ceil(total / this.perPage) : 1)

        if (total > this.perPage) {
          this.paginated = true
        }

        this.publicLists = response.data.data
        this.setPublicLists(response.data.data)
      }).catch((err) => {
        console.error(err)
        this.$generalNotification('Unable to load folders please try again.', 'error')
        this.setPublicListsLoaded(true)
        this.setPublicLists([])
        this.isLoading = false
      }).finally(() => {
        this.isLoading = false
        this.setPublicListsLoaded(true)
      })
    }
  }
}
